import { CardItem, TinyButton, tokens } from 'ComponentLibrary'
import { Box, Stack, Tooltip } from '@mui/material'
import { Headline } from 'ComponentLibrary/src/piazza/text/Headline/Headline'
import { DownloadSimpleIcon } from '@phosphor-icons/react'
import type { CustomerExistingValuation as ExistingValuation } from '@einwert/valuation-api-client'
import { exportAllValuesToExcel } from 'ClientPortal/src/pages/Assets/AssetDetails/AssetKeyValues/exportKeyValues'
import { useTranslation } from 'react-i18next'
import { useCurrentResolvedLocale } from 'ClientPortal/src/i18n/currentLocale'

type AllValuesExportCardProps = {
    addressText: string
    valuation: ExistingValuation
}

export function AllValuesExportCard({ addressText, valuation }: AllValuesExportCardProps) {
    const { t: tTerminologyCommon } = useTranslation('terminology', { keyPrefix: 'common' })
    const { t: tTerminologyExport } = useTranslation('terminology', { keyPrefix: 'export' })
    const locale = useCurrentResolvedLocale()

    return (
        <CardItem>
            <Stack direction="column" gap={tokens.SizingSpacing150}>
                <Headline variant="headline3" title={tTerminologyExport('sectionTitle')} />
                <Tooltip title={tTerminologyExport('allValues.downloadTooltip')}>
                    <Box>
                        <TinyButton
                            leftIcon={<DownloadSimpleIcon />}
                            label={tTerminologyExport('downloadExcelButtonLabel')}
                            onClick={() =>
                                exportAllValuesToExcel({ valuation, addressText, tTerminologyCommon, tTerminologyExport, locale })
                            }
                        />
                    </Box>
                </Tooltip>
            </Stack>
        </CardItem>
    )
}
